<template>
    <div>
        <editor :key="tinymceFlag" v-model="Editortext" :setting="setting" @change="change" :setup="setting.setup"></editor>
    </div>
</template>

<script>
import plugins from './plugins'
import toolbar from './toolbar'
import {fileUp} from '@/api/file'
export default {
    name: 'tinymce',
    props: {
        height: {
            type: [Number, String],
            required: false,
            default: 320
        },
        width: {
            type: [Number, String],
            required: false,
            default: "auto"
        },
        content: {
            //父组件传进来的默认值
            type: String,
            default: ""
        },
        itemkey: {
            //多个富文本用于区分,多个富文本必须传入此参数
            type: String,
            default: ""
        },
        custom: {
            //添加自定义菜单按钮
            type: String,
            default: ""
        }
    },
    activated() {
        this.tinymceFlag++; //组件缓存的时候用于再次加载，不然有些时候再次加载会出现只显示一个textarea的问题
    },
    data() {
        let _this = this;
        return {
            tinymceFlag: 1,
            Editortext: this.content,
            setting: {
                menubar: false, //上面的菜单隐藏
                selector: `#Editor${_this.itemkey}`, //多个富文本的时候加上itemkey用于区分
                toolbar: toolbar,
                plugins: plugins,
                language: "zh_CN", //本地化设置
                statusbar: false, //隐藏最底部的状态栏
                height: this.height, //默认高度
                width: this.width, //默认宽度
                image_advtab: true,
                setup: function(editor) {
                    editor.on("input blur undo redo execCommand", () => {
                        //多个触发事件获取最新值
                        var msg = _this.Editortext.toString(); //获取带html的值
                        if (_this.itemkey != undefined && _this.itemkey != "") {
                            //多个富文本时返回值给父组件
                            _this.$emit("message", {
                                key: _this.itemkey,
                                msg: msg
                            });
                        } else {
                            //单个富文本返回值给父组件
                            _this.$emit("message", msg)
                        }
                    });
                },
                // 图片异步上传处理函数
                images_upload_handler: (blobInfo, success, failure) => {
                    this.handleImageAdded(blobInfo, success, failure)
                }
            }
        };
    },
    watch: {
        content: {
            immediate: true,
            deep: true,
            handler() {
                // 这里是从列表页编辑时做的内容注入，没有需要可以不写
                if (this.content == undefined) {
                    this.Editortext = ""
                } else {
                    this.Editortext = this.content
                }
            }
        }
    },
    methods: {
        // 插入图片的方法
        handleImageAdded(blobInfo, success, failure) {
            let file = blobInfo.blob()
            var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1)
            const extension = testmsg === "jpg"
            const extension2 = testmsg === "png"
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!extension && !extension2) {
                failure("上传文件只能是 jpg、png格式!")
                return false;
            }
            if (!isLt2M) {
                failure("上传文件大小不能超过 2MB!")
                return false;
            }

            const formData = new FormData();
            formData.set("file", blobInfo.blob()) //imageFile文件名和后端统一

            //正常情况是请求后端接口，接口返回图片路径，通过success方法回显图片在编辑器里，
            //我这里为了演示，写死了图片，用的时候你把下面这行删除,走下方接口就行了
            /*success(
                "https://www.baidu.com/img/PCtm_d9c8750bed0b3c7d089fa7d55720d6cf.png"
            )*/
            fileUp(formData).then(response => {
                // 图片上传成功以后调用success,图片就可以在富文本编辑器中显示了
                if (response.code != 200)
                    console.log(failure)
                this.$message.error(response.msg)
                //console.log(success)
                success(response.data)
            })
        },
        change() {
            //这里只有输入框改变的时候才会触发，比如自定义模板选择的时候就触发不了
        }
    }
}
</script>

<style scoped>
.tox-dialog__body-nav > :nth-child(2) {
    display: none !important;
}
</style>
